import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient,  HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalModule } from 'ngx-bootstrap';

// Ng2-select
import { SelectModule } from 'ng-select';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';

// Datepicker
import { BsDatepickerModule } from 'ngx-bootstrap';

import { CustomInterceptor } from './../../../helper';
import { SharedModule } from '../../shared';

// Routing
import { ReportRoutingModule } from './report-routing.module';

import { ReportDetailComponent, ReportDetailService } from './report-detail';
import { ReportSummaryComponent } from './report-summary';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SelectModule,
    AngularMultiSelectModule,
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }),
    
    ReportRoutingModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [
    ReportDetailComponent,
    ReportSummaryComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    ReportDetailService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true }
  ],
})
export class ReportModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/report/report.module.ts